import { AlertTriangle } from "lucide-react";

export const AiDisclaimer = ({ className = "" }) => (
  <div
    data-testid="ai-disclaimer"
    className={`flex items-start gap-2 text-[11px] leading-snug text-amber-800/90 bg-amber-50 border border-amber-200/70 rounded-xl px-3 py-2 ${className}`}
  >
    <AlertTriangle size={13} className="text-amber-500 shrink-0 mt-0.5" />
    <span>
      Sugerencia generada por IA. Es solo una herramienta de apoyo y puede contener
      errores o información desactualizada; <b>no reemplaza el criterio médico profesional</b>.
    </span>
  </div>
);
